export const COLORS = {
  text: {
    primary: "#007aff",
    secondary: "#99999",
    accent: "#ff8500",
    info: "#22b6ff",
    success: "#2e7d32",
    warning: "#ed6c02",
    error: "#d32f2f",
    white: "#ffffff",
    black: "#222222",
    gray100: "#F5F5F5",
    gray200: "#EEEEEE",
    gray300: "#E0E0E0",
    gray400: "#BDBDBD",
    gray600: "#757575",
    gray700: "#616161",
    gray800: "#424242",
  },
  background: {
    primary: "#007aff",
    primaryLight: "#007aff1c",
    secondary: "#99999",
    accent: "#ff8500",
    info: "#22b6ff",
    success: "#2e7d32",
    successLight: "#2e7d321c",
    warning: "#ed6c02",
    warningLight: "#ed6c021c",
    error: "#d32f2f",
    errorLight: "#d32f2f1c",
    infoLight: "#f2e8f5",
    white: "#ffffff",
    black: "#222222",
    gray: "#666",
    gray50: "#FAFAFA",
    gray100: "#F5F5F5",
    gray200: "#EEEEEE",
    gray300: "#E0E0E0",
    gray400: "#BDBDBD",
    gray600: "#757575",
    gray700: "#616161",
    gray800: "#424242",
  },
  border: {
    primary50: "#e3f4ff",
    primary100: "#bbe2ff",
    primary200: "#8dd0ff",
    primary: "#007aff",
    secondary: "#99999",
    accent: "#ff8500",
    info: "#22b6ff",
    success: "#2e7d32",
    warning: "#ed6c02",
    error: "#d32f2f",
    white: "#ffffff",
    black: "#222222",
    gray: "#666",
    gray50: "#FAFAFA",
    gray100: "#F5F5F5",
    gray200: "#EEEEEE",
    gray300: "#E0E0E0",
    gray400: "#BDBDBD",
  },
  transparent: "transparent",
};
